import React from 'react'
import { Text, Box } from 'rebass'
import styled from 'styled-components'

const Wrap = styled(Box)`
  p + p {
    margin-top: ${props => props.theme.space[3]}px;
  }

  p {
    font-family: ${props => props.theme.fonts.serif};
    font-size: 18px;
    line-height: 1.65;

    @media (min-width: ${props => props.theme.breakpoints[0]}) {
      font-size: 20px;
    }
  }
`

const SaraExcerpt = () => (
  <Wrap>
    <Text as="p">
      It was minus-twenty degrees Celsius, and I wasn’t wearing long johns under
      my ripped jeans. The exposed skin on my knees had turned purple, and the
      wind burned my cheeks and the tips of my ears. Burying our hands in the
      shallow pockets of our winter coats, Tegan and I didn’t speak as we made
      our way from the bus stop on the highway across the subdivision’s shortcut
      to our house. At home, we hovered near the back deck. We smoked a pinch of
      weed I spilled into a crushed Coke can punctured with pinholes.
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      “Hurry,” is all Tegan mustered as I flicked the lighter with my frozen
      thumb, forcing sparks but no flame. “Give it to me; we’ll die out here.”
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      Sucking deeply, she passed the can back and I inhaled the smoke lacing out
      of the hole. When we got inside, I should have done homework, but I went
      straight to the basement, where I used Mom’s computer to write secret
      letters about the girl I liked. It was still a shock to feel desire for
      girls, addictive thoughts that stole hours of my time at school and in bed
      before I fell asleep.
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      Girls had always been interested in Tegan and me. They sometimes followed
      us home from school or watched us at choir practice. As a twin, I was used
      to being stared at by people, but this was different. I started imagining
      them observing me, even when I was alone. I wanted these girls to look at
      me; I wanted to be seen.
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      Tegan came into the office and flipped on the television. “What are you
      writing?”
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      “Nothing.”
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      I always told lies to protect her from what scared me, but this one I told
      only to protect myself. I printed what I was working on and walked
      upstairs to my bedroom, where I stashed the pages deep inside the torn-out
      gut of a stuffed animal. A few months earlier Mom had come into my room
      and read a few lines of a letter I’d accidentally left in the printer tray
      downstairs. It was addressed to my best friend, Naomi.
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      “Do you like Naomi as more than a friend?” she asked, saying each word
      carefully.
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      My arms and cheeks went numb. “I just wrote the words to see what it would
      feel like.”
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      Her face softened, and she placed the paper next to me on the bed. “You
      know, when I was fifteen—”
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      “Mom, I don’t want to hear again about how you kissed a girl at boarding
      school!”
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      She flinched. “Well, in the future, if you don’t want people to read your
      thoughts, then don’t leave them where everyone can find them.”
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      A few weeks later, Tegan found my letter stash, pulled them straight from
      the guts of my hiding place. “Stay out of my shit!” I hollered at her,
      ripping the papers from her hands, then slamming both our bedroom doors so
      hard the windows rattled. I cut each page into strips and threw them in
      the garbage. Then I called Naomi and told her what I’d done.
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      “I wish you hadn’t thrown them away. They were so beautiful.”
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      “No one in this house respects me or my privacy!”
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      I knew both Mom and Tegan were trying to figure out what was going on with
      me. But the harder they looked, the more I wanted to retreat. I was afraid
      of being caught in a trap.
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      I wasn’t just kissing girls.
    </Text>
    <Text as="p" css={{ textIndent: 32 }}>
      I was in love with my best friend.
    </Text>
  </Wrap>
)

export default SaraExcerpt
